<template>
  <div class="loading">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<style scoped lang="scss">
.loading {
  display: inline-block;
  position: relative;
  width: 80px;
  display: flex;
  align-items: center;
}
.loading div {
  position: absolute;
  //   top: 66px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: linear;
}
.loading div:nth-child(1) {
  left: 8px;
  animation: loading1 0.6s infinite;
}

@keyframes loading1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
.loading div:nth-child(4) {
  left: 56px;
  animation: loading4 0.6s infinite;
}

@keyframes loading4 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

.loading div:nth-child(2) {
  left: 8px;
  animation: loading2 0.6s infinite;
}

.loading div:nth-child(3) {
  left: 32px;
  animation: loading2 0.6s infinite;
}
@keyframes loading2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
